import { TargetSchemaItem } from '../authentication-method-policy-utlity';
import { AuthenticationMethodsFido2Schema, Fido2AuthenticationMethodConfigurationForm } from './model';

export function updateAuthenticationMethodsFido2Schema(
    form: Fido2AuthenticationMethodConfigurationForm,
): AuthenticationMethodsFido2Schema {
    if (form.state === 'disabled') {
        return {
            type: 'object',
            properties: {
                state: { type: 'string', const: form.state },
            },
        };
    }

    const includedTargetsOneOfItems: TargetSchemaItem[] = form.includeTargets.includedGroups.map((group) => ({
        properties: {
            id: { type: 'string', const: group.id },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    const excludeTargetsOneOfItems: TargetSchemaItem[] = form.excludeTargets.map((group) => ({
        properties: {
            id: { type: 'string', const: group },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    const schema: AuthenticationMethodsFido2Schema = {
        type: 'object',
        properties: {
            state: { type: 'string', const: form.state },
            isSelfServiceRegistrationAllowed: {
                type: 'boolean',
                const: form.isSelfServiceRegistrationAllowed,
            },
            isAttestationEnforced: {
                type: 'boolean',
                const: form.isAttestationEnforced,
            },
            keyRestrictions: {
                type: 'object',
                properties: {
                    isEnforced: { type: 'boolean', const: form.keyRestrictions.isEnforced },
                    ...(form.keyRestrictions.isEnforced && {
                        enforcementType: {
                            type: 'string',
                            const: form.keyRestrictions.enforcementType,
                        },
                        aaGuids: {
                            type: 'array',
                            const: form.keyRestrictions.aaGuids,
                        },
                    }),
                },
            },
            includeTargets:
                includedTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: includedTargetsOneOfItems,
                          },
                          minItems: includedTargetsOneOfItems.length,
                          maxItems: includedTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },
            excludeTargets:
                excludeTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: excludeTargetsOneOfItems,
                          },
                          minItems: excludeTargetsOneOfItems.length,
                          maxItems: excludeTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },
        },
    };

    return schema;
}
